import { ErrorMessage, Field } from 'formik';
import React from 'react';
import ReportIssueError from '../../../../reportissue/components/ReportIssueError';
import './ReportProblemForm.css';

export default function FormikCustomSelect({
  selectLabel,
  selectName,
  selectList,
  validateSelection,
  convertSelectValueToNumber,
  selectFilter = [],
}) {
  return (
    <div className="form-select">
      <label htmlFor={selectName} className="form-label">
        {selectLabel}
      </label>
      <Field
        component="select"
        id={selectName}
        name={selectName}
        className="form-problem-field "
        onClick={validateSelection}
        onChange={(e) => convertSelectValueToNumber(selectName, e)}
      >
        <option value="" disabled>
          Odaberi opciju
        </option>
        {selectFilter?.length > 0
          ? Object.keys(selectList).map(
              (key) =>
                selectFilter.includes(selectList[key].value) && (
                  <option key={key} value={selectList[key].value}>
                    {selectList[key].label}
                  </option>
                )
            )
          : Object.keys(selectList).map((key) => (
              <option key={key} value={selectList[key].value}>
                {selectList[key].label}
              </option>
            ))}
      </Field>
      <ErrorMessage name={selectName} component={ReportIssueError} />
    </div>
  );
}
